<div class="navigation flex items-center container">
  <app-navigation-item *ngFor="let item of items" [item]="item"></app-navigation-item>
</div>

